import React from "react";
import { useModalHardwareInstallHook } from "./modal-hardware-install-hooks";

type ContextModalHardwareInstall = ReturnType<
  typeof useModalHardwareInstallHook
>;
export const ModalHardwareInstallContext =
  React.createContext<ContextModalHardwareInstall | null>(null);

export function useContextModalHardwareInstall() {
  const context = React.useContext(ModalHardwareInstallContext);

  if (!context) {
    throw new Error(
      "useContextModalHardwareInstall must be used within a ContextModalHardwareInstallProvider",
    );
  }

  return context;
}
